// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import slaEntity from './entities/sla.json';
import slaMenu from '../pages/sla/menu.json';
import slaFullForm from '../pages/sla/forms/full.json';
import slaContextForm from '../pages/sla/forms/context.json';
import slaMiniForm from '../pages/sla/forms/mini.json';
import slaLookupForm from '../pages/sla/forms/lookup.json';
import slaTableView from '../pages/sla/views/table.json';
import slaStagesView from '../pages/sla/views/stages.json';
import slaCardsView from '../pages/sla/views/cards.json';
import slaInlineView from '../pages/sla/views/inline.json';
import slaBacklogView from '../pages/sla/views/backlog.json';
import slaSplitView from '../pages/sla/views/split.json';
import slaCalendarView from '../pages/sla/views/calendar.json';
import slaDashboardView from '../pages/sla/views/dashboard.json';

/** Тип запису «Політика SLA» зі сторінками пакета: меню, форми та подання з pages/sla/. */
export const slaDefinition: IRecordTypeDefinition = {
  ...slaEntity,
  views: assembleViewSet({
      table: slaTableView,
      stages: slaStagesView,
      cards: slaCardsView,
      inline: slaInlineView,
      backlog: slaBacklogView,
      split: slaSplitView,
      calendar: slaCalendarView,
      dashboard: slaDashboardView,
  }),
  form: slaFullForm,
  forms: { full: slaFullForm, context: slaContextForm, mini: slaMiniForm, lookup: slaLookupForm },
  menu: slaMenu,
} as IRecordTypeDefinition;
